import { render, staticRenderFns } from "./DSaveMappingChangesConfirmation.vue?vue&type=template&id=71023875&scoped=true&"
import script from "./DSaveMappingChangesConfirmation.vue?vue&type=script&lang=js&"
export * from "./DSaveMappingChangesConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DSaveMappingChangesConfirmation.vue?vue&type=style&index=0&id=71023875&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71023875",
  null
  
)

export default component.exports